import React from 'react';
import { accountSearchColumns, khachHangSearchColumns, QUERY_KEYS } from '@/constants';
import { AccountModel, KhachHang } from '@/types/schemas';
import { SearchField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface DetailTabProps {
  searchFieldState: {
    selectedCreditAccount: AccountModel | null;
    setSelectedCreditAccount: (account: AccountModel | null) => void;
    selectedCustomer: KhachHang | null;
    setSelectedCustomer: (customer: KhachHang | null) => void;
  };
}

const DetailTab = ({ searchFieldState }: DetailTabProps) => {
  return (
    <div className='p-4'>
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã khách hàng</Label>
        <SearchField<KhachHang>
          type='text'
          name='ma_kh'
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          dialogTitle='Danh mục đối tượng'
          value={searchFieldState.selectedCustomer?.customer_code}
          relatedFieldValue={searchFieldState.selectedCustomer?.customer_name}
          onRowSelection={searchFieldState.setSelectedCustomer}
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-[150px]'>Tài khoản có</Label>
        <SearchField<AccountModel>
          type='text'
          name='tk_co'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          dialogTitle='Danh mục tài khoản'
          value={searchFieldState.selectedCreditAccount?.code}
          relatedFieldValue={searchFieldState.selectedCreditAccount?.name}
          onRowSelection={searchFieldState.setSelectedCreditAccount}
        />
      </div>
    </div>
  );
};

export default DetailTab;
